export function convertIsoDates(obj: unknown) : unknown {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/

  if (Array.isArray(obj)) {
    return obj.map(convertIsoDates)
  }

  if (obj && typeof obj === 'object') {
    const record = obj as Record<string, unknown>

    for (const key in record) {
      if (!Object.prototype.hasOwnProperty.call(record, key)) continue

      const value = record[key]

      if (typeof value === 'string' && isoDateRegex.test(value)) {
        record[key] = new Date(value)
      } else if (value && typeof value === 'object') {
        record[key] = convertIsoDates(value)
      }
    }
  }

  return obj
}